"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataImportModule = void 0;
const tslib_1 = require("tslib");
const ModuleConstants = tslib_1.__importStar(require("../Utilities/Constants/ModuleConstants"));
const AdaptableModuleBase_1 = require("./AdaptableModuleBase");
class DataImportModule extends AdaptableModuleBase_1.AdaptableModuleBase {
    constructor(api) {
        super(ModuleConstants.DataImportModuleId, ModuleConstants.DataImportFriendyName, 'import', 'DataImportPopup', 'Import Data', api);
    }
    addModuleMenuItem(source) {
        if (this.isModuleAvailable()) {
            return this.getOpenPopupMenuItem(source);
        }
    }
    addContextMenuItems() {
        if (this.isModuleAvailable()) {
            return [this.getOpenPopupMenuItem('ContextMenu')];
        }
        return undefined;
    }
    addColumnMenuItems() {
        if (this.isModuleAvailable()) {
            return [this.getOpenPopupMenuItem('ColumnMenu')];
        }
    }
    getOpenPopupMenuItem(source) {
        const moduleParams = {
            action: 'New',
            source: source,
            maxWidth: this.getPopupMaxWidth(),
        };
        return this.createColumnMenuItemShowPopup('Import Data', this.moduleInfo.Popup, this.moduleInfo.Glyph, moduleParams);
    }
}
exports.DataImportModule = DataImportModule;
